import * as React from "react";

function Cars(props) {
  return (
    <svg width={20} height={20} fill="none" {...props}>
      <path
        d="M10.715 15.714a5 5 0 110-10 5 5 0 010 10zm0-8.571a3.571 3.571 0 100 7.143 3.571 3.571 0 000-7.143z"
        stroke="none"
        fill="currentColor"
      />
      <path
        d="M8.571 11.786a1.072 1.072 0 100-2.143 1.072 1.072 0 000 2.143zm4.286 0a1.072 1.072 0 100-2.144 1.072 1.072 0 000 2.144zm-2.143-2.143a1.071 1.071 0 100-2.143 1.071 1.071 0 000 2.143zm0 4.286a1.072 1.072 0 100-2.144 1.072 1.072 0 000 2.144z"
        stroke="none"
        fill="currentColor"
      />
      <path
        d="M6.493 10.714H.714A.715.715 0 010 10 10 10 0 0110 0a.714.714 0 01.714.714v5.779a.714.714 0 01-.593.714A3.571 3.571 0 007.2 10.13a.714.714 0 01-.707.585zM1.429 9.286h4.5a5 5 0 013.357-3.357v-4.5a8.571 8.571 0 00-7.857 7.857z"
        stroke="none"
        fill="currentColor"
      />
      <path
        d="M10.713 20a9.286 9.286 0 01-9.285-9.286c0-.264 0-.514.035-.771a.714.714 0 01.715-.657h3.75a5 5 0 013.357-3.358v-3.75a.714.714 0 01.657-.714c.257-.036.507-.036.771-.036a9.286 9.286 0 110 18.572zm-7.857-9.286a7.857 7.857 0 107.857-7.857v3.636a.714.714 0 01-.592.714 3.571 3.571 0 00-2.922 2.922.714.714 0 01-.714.592l-3.629-.007z"
        stroke="none"
        fill="currentColor"
      />
    </svg>
  );
}

const CarsIcon = React.memo(Cars);
export default CarsIcon;
